window.arSalesInvoiceCreditedByFormatter = function(value, row) {
    let html = '';
    if (row.credited_by) {
        html += '<a href="/ar/sales/invoices/show/' + row.credited_by_id + '">';
        html += row.credited_by;
        html += '</a>';
    }
    return html;
}
